export default "__VITE_ASSET__Ceh$Jrn3__"